var map = {
	"./300x300.svg": 4780,
	"./Nueva carpeta/disney.png": 6292,
	"./Nueva carpeta/netflix.png": 2654,
	"./Nueva carpeta/spotify.png": 8016,
	"./Nueva carpeta/youtube.png": 3637,
	"./amazon.png": 1048,
	"./amazonprime.jpg": 4215,
	"./atm-card.png": 8739,
	"./binance.png": 3564,
	"./bitcoin.png": 6776,
	"./garantizado.png": 5600,
	"./hbo.png": 3295,
	"./max.jpg": 3104,
	"./netflix.png": 6270,
	"./oferta-especial.png": 3664,
	"./paypal.png": 5597,
	"./spotify.jpg": 2884,
	"./transfer.png": 4269,
	"./youtube.jpg": 8229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4034;